module.exports = __webpack_public_path__ + "img/TDE_Bow.552f292a.png";